import * as React from 'react';
import style from './RelatedContent.scss';
import { Text } from '../../PageElements/Text';
import { RelatedContentList } from './RelatedContentList';

interface RelatedContentItem {
  icon: string; // The name of the icon of related content
  text: string; // Description of what the content is. can be used as the display name for the link.
  url: string; // The url of the related content
}

interface RelatedContentProps {
  relatedContent: RelatedContentItem[];
}

export const RelatedContent = ({
  relatedContent = [],
}: RelatedContentProps) => {
  const hasRelatedContent = relatedContent.length > 0;
  return hasRelatedContent ? (
    <div className={style.relatedContentNewWrapper} data-hook="related-content">
      {/* @ts-ignore TODO */}
      <Text className={style.title} size="medium" weight="bold">
        Related Content
      </Text>
      <RelatedContentList relatedContentList={relatedContent} />
    </div>
  ) : null;
};
